import { createBrowserRouter } from 'react-router-dom';
import AdminLayout from './Admin';
import { Dashboard } from './components/Dashboard';
import { Pulse } from './components/Pulse';
import { PulseDetail } from './components/PulseDetail';
import { AppProvider } from './contexts';
import Auth from './pages/Auth';
import AuthError from './pages/Auth/Error';
import OnboardingPage from './pages/Onboarding';

export const router = createBrowserRouter([

    {
        path: '/',
        element: <AppProvider />,
        children: [
            {
                path: '/auth',
                element: <Auth />
            },
            {
                path: '/auth/error',
                element: <AuthError />
            },
            {
                path: '/onboarding',
                element: <OnboardingPage />
            },
            {
                element: <AdminLayout />,
                children: [
                    {
                        index: true,
                        element: <Dashboard />
                    },
                    {
                        path: 'pulse',
                        element: <Pulse />
                    },
                    {
                        path: 'pulse/:pulseId',
                        element: <PulseDetail />
                    }
                ]
            }
        ]
    }
], {basename: '/admin'});